import axios from 'axios';
import Vue from 'vue'

export default {
    

    uploadImage(formData){
        return axios.post("/api/design/add/image", formData )
        .then(response => {
            if (response && response.data) {
                Vue.prototype.$snotify.success("Image ajouter avec succès");
                return response.data;
            }
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getBagDesignByCode(bagDesignCode){
        return axios.get("/api/design/get/model/"+bagDesignCode )
        .then(response => {
            if (response && response.data) {
                return response.data;
            }
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    saveBagDesign(bagDesign){
        return axios.post("/api/design/save" , bagDesign )
        .then(response => {
            if (response && response.data) {
                return response.data;
            }
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },


    downloadLogo(code, url) {
        return axios.get('/api/image/get/'+url , { responseType: 'arraybuffer' })
            .then(response => {
                if (response && response.data) {
                    const blob = new Blob([response.data], { type: 'application/octet-stream' });

                    const link = document.createElement('a');
                    const url = window.URL.createObjectURL(blob);
                    link.href = url;

                    link.download = `logo-${code}.png`;

                    document.body.appendChild(link);
                    link.click();

                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(url);
                }
            })
            .catch(error => {
                Vue.prototype.$snotify.error(error?.response?.data || error.message || 'Download failed');
            });
    }
 

}